module.exports = __webpack_public_path__ + "static/media/WAStateElection2021LogoDesktop.a5fdeff4.svg";